export default __webpack_public_path__ + "static/media/fastrewind02.4d4f42e5.svg";